import { Circle, Rect, Vector2 } from "peet-math";
import { Control } from "./control";
import { ViewPort } from "./viewport";
import { CSSDummyStyle, getSeatBoudingBox, isPointInsideCircle } from "./util";
import { PlanSeat, SeatStatusEnum } from "./plan-seat";
import { GestureVenuePlan } from "./gesture-venue-plan";


export class SeatControl extends Control {
    public containerTag: JQuery<HTMLElement>;
    public venuePlan: GestureVenuePlan;
    //public planSettings: PlanSettings;

    public seat: PlanSeat;
    public boundingBox: Rect;
    public style: CSSDummyStyle;
    public hoverStyle: CSSDummyStyle;
    public cssDummy: any;
    public isClickable: boolean = false;
    public isMouseOver: boolean = false;

    constructor(venuePlan: GestureVenuePlan, seat: PlanSeat) {
        super()
        this.render = this.render.bind(this);
        this.venuePlan = venuePlan;
        this.seat = seat;

        this.containerTag = this.venuePlan.viewPortTag;
        this.refreshState();
    }
    
    public setState(state: SeatStatusEnum) {
        this.seat.state = state;
        this.refreshState();
    }

    public refreshState() {
        this.boundingBox = getSeatBoudingBox(this.seat);
        const [ style, hoverStyle ] = this.venuePlan.getSeatStyle(this.seat.state);
        this.style = style;
        this.hoverStyle = hoverStyle;
        this.isClickable = this.venuePlan.settings.clickableSeatMode 
            && (this.seat.state === SeatStatusEnum.AVAILABLE || this.seat.state === SeatStatusEnum.SELECTED);
    }

    
    public override isPlanPointInside?(point: Vector2): boolean {
        return isPointInsideCircle(this.getBoundingCircle(), point);
    }

    public override isViewportPointInside?(viewport: ViewPort, point: Vector2): boolean {
        return isPointInsideCircle(this.getVPBoundingCircle(viewport), point);
    }

    public override handleMouseIn?(viewport: ViewPort, _point: Vector2) { 
        if(this.isClickable) {
            viewport.viewPortTag.css('cursor', 'pointer');
            this.isMouseOver = true;
        }
    }
    public override handleMouseOut?(viewport: ViewPort, _point: Vector2) { 
        if(this.isClickable) {
            viewport.viewPortTag.css('cursor', 'auto');
            this.isMouseOver = false;
        }
    }

    private getBoundingCircle(): Circle {
        return new Circle(this.boundingBox.getCenter(), this.boundingBox.width / 2); // div by 2 because it's a radius
    }

    private getVPBoundingCircle(viewport: ViewPort): Circle {
        const posOnView = viewport.pointPToV(this.boundingBox.getCenter());
        const radius = viewport.scalarPToV(this.boundingBox.width / 2); // div by 2 because it's a radius
        return new Circle(posOnView, radius);
    }

    render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
        if (this.visible) {

            //const posOnView = viewport.pointPToV(this.boundingBox.getCenter());
            // If canvas available:
            if (canvasCtx != null) {
                const cir = this.getVPBoundingCircle(viewport);

                const c = canvasCtx;
                //const radius = viewport.scalarPToV(this.boundingBox.width / 2); // div by 2 because it's a radius

                c.beginPath();
                //c.arc(posOnView.x, posOnView.y, radius, 0, 2 * Math.PI, false);
                c.arc(cir.center.x, cir.center.y, cir.radius, 0, 2 * Math.PI, false);
                
                c.fillStyle = this.isMouseOver ? this.hoverStyle.backgroundColor : this.style.backgroundColor;
                c.fill();
                c.lineWidth = 3;
                c.strokeStyle = this.isMouseOver ? this.hoverStyle.borderColor : this.style.borderColor;
                c.stroke();
            }
        }
    }
}